import styled from 'styled-components'
import { em } from 'polished'

import { Text } from 'shared/Typography'

import { imgMap, imgMapMob } from './assets'

const bgSizes = {
  mob: {
    1: '40%',
    2: 'contain',
    3: 'auto 93%',
  },
  desktop: {
    1: '92%',
    2: 'contain',
    3: '90%',
  }
}

const bgPositions = {
  mob: {
    1: 'right center',
    2: 'right center',
    3: 'right bottom',
  },
  desktop: {
    1: 'right 84%',
    2: 'right bottom',
    3: 'left bottom',
  }
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${em(15)} ${em(15)} ${em(15)};
  background-color: #F7F7F9;
  border-radius: ${em(30)};
  background-repeat: no-repeat;
  background-size: ${p => bgSizes.mob[p.number]};
  background-position: ${p => bgPositions.mob[p.number]};
  background-image: url(${p => imgMapMob[p.number]});

  ${p => p.theme.mq.upMd} {
    background-size: contain;
  }

  ${p => p.theme.mq.upLg} {
    padding: ${em(30)} ${em(30)} ${em(320)};
    background-image: url(${p => imgMap[p.number]});
    background-position: ${p => bgPositions.desktop[p.number]};
    background-size: ${p => bgSizes.desktop[p.number]};
  }

  ${p => p.theme.mq.upThreshold(1400)} {
    padding-bottom: ${em(410)};
  }
`

export const Title = styled(Text)`
  max-width: ${em(156)};

  ${p => p.theme.mq.upLg} {
    max-width: none;
  }

  span {
    font-weight: 500;
  }
`

export const Number = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${em(24, 14)};
  height: ${em(24, 14)};
  margin-bottom: ${em(10)};
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), #000000;
  color: var(--color-W100);
  border-radius: 100%;

  ${({ theme }) => theme.mq.downMd} {
    line-height: unset;
  }

  ${p => p.theme.mq.upMd} {
    width: ${em(30, 16)};
    height: ${em(30, 16)};
  }
`
